import { mapGetters } from 'vuex';

export default {
    name: 'propertyDescNew',
    inject: ['$eventBus'],
    data() {
        return {
            descriptionExpanded: false,
            basicInfoDisclaimer: '',
            brokerInfo: null,
            rentalInfo: {},
            brokerInfoDetails: '',
            complianceHidePhone: false,
            showMLSCheckTimestamp: false,
            rentalUrl: '',
            descriptionExpandable: false,
            showAgentInfo: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'favoriteListings']),
        ...mapGetters('dpp', ['dpp', 'getMlsInfo', 'getUpdatedStatus']),
        showExpandLink() {
            return this.listingAgent || this.descriptionExpandable;
        },
        toggleDescription() {
            this.descriptionExpanded = !this.descriptionExpanded;
        },
        nhsExternalLink() {
            var link = 'https://www.newhomesource.com/?refer=Movoto';
            if (this.dpp.features && this.dpp.features.length && this.dpp.isNHS) {
                var planInformation = this.dpp.features.filter((feature) => feature.name === 'Plan Information');
                if (planInformation && planInformation.length) {
                    link = planInformation[0].value
                        .filter((pI) => {
                            return pI.name === 'Plan Details';
                        })[0]
                        .value.filter((pD) => {
                            return pD.name === 'Home Details Website';
                        })[0].value;
                }
            }
            return link;
        },
        rdcExternalLink() {
            const citySlug = this.dpp.geo.city.trim().replace(/\s+/g, '-');
            return `https://www.realtor.com/newconstructionhomes/${citySlug}_${this.dpp.geo.state}`;
        },
        listingAgent() {
            let prefix = '';
            if (this.dpp.listingAgent) {
                if (this.getMlsInfo.id == 484) {
                    prefix = 'Listing Courtesy of ';
                }
                return prefix + this.dpp.listingAgent;
            }
        },
        mlsLogoSrc() {
            if (this.getMlsInfo.id) {
                return `${this.glb.cdnUrl}images/desktop/logo/logo_${this.getMlsInfo.id}.png`;
            }
        },
        lastChecked() {
            if (
                this.getUpdatedStatus.lastChecked &&
                this.getUpdatedStatus.lastChecked != this.getUpdatedStatus.lastUpdate &&
                ~['ACTIVE', 'PENDING', 'SOLD', 'FOR_RENT'].indexOf(this.dpp.houseRealStatus)
            ) {
                return this.getUpdatedStatus.lastChecked;
            }
        },
        dppDescription() {
            return this.dpp.showAsPR ? this.dpp.publicRecordDescription : this.dpp.description;
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        sendGA() {
            this.$eventBus.$emit('ga', { ec: 'partner', en: 'NHS_link_clicked', el: 'NHS', props: { link_name: 'Newhomesource.com' } });
        },
        initComplainceInfo() {
            this.isMounted = true;
            const compliance = this.getComplianceMethod()();
            const rules = compliance[0] && compliance[0].rule;
            this.complainceInfo = compliance[0] || {};
            this.rentalInfo = (this.complainceInfo && this.complainceInfo.rentals) || {};
            this.brokerInfo = this.complainceInfo && this.complainceInfo.broker;
            if (compliance[0] && compliance[0].rule.indexOf('disclaimerUnderBasicInfo') >= 0) {
                let office = this.dpp.complianceListOffice || '';
                this.basicInfoDisclaimer = compliance[0].desc1.replace(/\[ListingOfficeName\]/gi, office);
            }
            if (rules && rules.length && rules.indexOf('showMLSCheckTimestamp') >= 0) {
                if (this.getUpdatedStatus && this.getUpdatedStatus.mlsCheckedTimestamp) {
                    this.showMLSCheckTimestamp = true;
                }
            }

            if (this.brokerInfo) {
                let details = [];
                this.brokerInfo.dppBrokerName && details.push(this.brokerInfo.dppBrokerName);
                this.brokerInfo.dppBrokerLicense && details.push(`License #${this.brokerInfo.dppBrokerLicense},`);
                this.brokerInfo.dppBrokerOffice && details.push(this.brokerInfo.dppBrokerOffice);
                this.brokerInfo.dppBrokerAddress && details.push(this.brokerInfo.dppBrokerAddress);
                this.brokerInfoDetails = details.join(' ');
            }
            if (rules && rules.length && rules.indexOf('hidePhoneIcon') >= 0) {
                if (this.brokerInfo && this.brokerInfo.dppBrokerPhone) {
                    this.complianceHidePhone = true;
                }
            }
            if (this.dpp.isRentals) {
                this.rentalUrl = this.glb.rentalLink || this.rentalInfo.source || this.rentalInfo.urlrefer || '';
            }
            //check if overflow
            if (this.$refs.description && this.$refs.description.scrollHeight > this.$refs.description.clientHeight) {
                this.descriptionExpandable = true;
            }
            if (rules && rules.length && rules.indexOf('showBroker') >= 0) {
                this.showAgentInfo = true;
            }
        },
    },
    mounted() {
        this.initComplainceInfo();
    },
};
